import AddImage from './AddImage';

export default AddImage;
